import React from 'react';

import Container from 'react-bootstrap/Container';

function ActionSection() {
  return (
    <div className="site-section" id="gray-background">
      <Container className="centered">
        <br />
        <h1 className="heading">Learn more about Big & Mini for organizations</h1>
        <br />
        <h3>We are here to help!</h3>
        <br />
        <a href="orgsignup" className="dark-button">
          Get in touch
        </a>
      </Container>

    </div>
  );
}
export default ActionSection;
